<template>
  <svg
    class="custom-icon"
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M0 14.7018C0 15.8332 0.861792 16.75 1.92669 16.75L16.0733 16.7498C17.1369 16.7498 18 15.8355 18 14.7077V5.83761C18 4.70898 17.1357 3.79538 16.0706 3.79538H9.96543C9.82343 3.79538 9.57739 3.65525 9.49819 3.52932L8.92876 2.12346C8.6117 1.61908 7.96293 1.25 7.39257 1.25H1.93059C0.862425 1.25 0 2.16635 0 3.2983V14.7018ZM9 6.25C8.44772 6.25 8 6.69772 8 7.25V9.25H6C5.44772 9.25 5 9.69771 5 10.25C5 10.8023 5.44772 11.25 6 11.25H8V13.25C8 13.8023 8.44772 14.25 9 14.25C9.55228 14.25 10 13.8023 10 13.25V11.25H12C12.5523 11.25 13 10.8023 13 10.25C13 9.69772 12.5523 9.25 12 9.25H10V7.25C10 6.69772 9.55228 6.25 9 6.25Z"
    />
  </svg>
</template>
